import React from 'react';
import { observer } from 'mobx-react';

// Dependencies
import DOMPurify from 'dompurify';
import Phone, { isValidPhoneNumber } from 'react-phone-number-input';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';
import Step from '../Common/Step';
import AudioRecorder from '../AudioRecorder/AudioRecorder';
import UserSettings from '../Settings/UserSettings';

const LegacyEnrollment = observer(class LegacyEnrollment extends React.Component {
  constructor() {
    super();
    this.setStep = this.setStep.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.toggleTextForm = this.toggleTextForm.bind(this);
    this.startRecording = this.startRecording.bind(this);
    this.setVoice = this.setVoice.bind(this);
    this.removeVoice = this.removeVoice.bind(this);
  }

  componentWillMount() {
    this.state = {
      step: 1,
      textPhone: null,
      showTextForm: false,
      textFormSent: false,
      recordingSupport: navigator.getUserMedia,
      voiceRecording: null,
      hasRecorded: false,
      showVoicePhone: false
    }
  }

  handlePhoneInput(e) {
    this.setState({
      textPhone: e
    });
  }

  setStep(e, step) {
    e.preventDefault();
    this.setState({
      step
    });
  }

  nextStep(e) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step: this.state.step + 1
    });
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  toggleTextForm(e) {
    e.preventDefault();
    this.setState({
      showTextForm: !this.state.showTextForm,
      textFormSent: false
    });
  }

  sendLink(e) {
    e.preventDefault();
    this.setState({
      textFormSent: true,
      showTextForm: false
    });

    const _this = this;

    setTimeout(function(){
      _this.nextStep();
    }, 5000);
  }

  isActive(step) {
    if(this.state.step === step) {
      return 'slide-active';
    } else if(this.state.step > step) {
      return 'slide-hidden-before';
    } else {
      return 'slide-hidden-after';
    }
  }

  startRecording() {
    this.setState({
      hasRecorded: true
    });
  }

  setVoice(voiceRecording) {
    this.setState({
      voiceRecording
    });
  }

  removeVoice() {
    this.setState({
      voiceRecording: null,
      hasRecorded: false
    });
  }

  toggleVoicePhone(e) {
    e.preventDefault();
    this.setState({
      showVoicePhone: !this.state.showVoicePhone
    });
  }

  render() {
    const { translation } = this.props;
    let prod = false;
    let steps = translation.steps;

    if(process.env.REACT_APP_ENVIRONMENT === 'production') {
      prod = true;
    }

    if(prod) {
      steps = [
        "Welcome",
        "Settings"
      ]
    }

    return(
      <main tabIndex="0" id="main-content" className="page wrap">
        <div className="page--brief">
          <Step step={this.state.step} setStep={this.setStep} data={steps} skippable={false} />
        </div>

        <div className="slide-wrap">
          <div className={`panel panel--brief ${this.isActive(1)}`}>
            <h1 className="panel__title">{translation.welcome.heading}</h1>

            {prod &&
              <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(translation.welcome.body)}}></div>
            }

            {!prod &&
              <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(translation.welcome_sid.body)}}></div>
            }

            <button className="btn btn--icn-right next" onClick={(e) => {this.nextStep(e)}}>
              {translation.welcome.button}
              <icons.iconCircleRight />
            </button>
          </div>

          <section id="#id-settings" className={`${this.isActive(2)}`}>
            <UserSettings enrollment={true} nextStep={this.nextStep} {...this.props} />
          </section>

          {!prod &&
            <section id="#id-options" className={`panel panel--brief ${this.isActive(3)}`}>
              <h2 className="panel__title">{translation.photo_id.heading}</h2>

              {!this.state.showTextForm && !this.state.textFormSent &&
                <div>
                  <h5>{translation.photo_id.sub_heading}</h5>
                  <a className="btn" href="#text-form" onClick={(e) => {this.toggleTextForm(e)}}><icons.iconCamera />{translation.photo_id.button}</a>
                  <span className="preposition--vertical">{translation.photo_id.or}</span>
                  <label className="lbl-file" htmlFor="enrollment-tel-upload">{translation.photo_id.upload}</label>
                  <input type="file" id="enrollment-tel-upload" />
                </div>
              }

              {this.state.showTextForm && !this.state.textFormSent &&
                <form onSubmit={(e) => {this.sendLink(e)}}>
                  <ul id="text-form" className="fields">
                    <li>
                      <label className="lbl-long" htmlFor="enrollment-tel">{translation.photo_id.phone.label}</label>
                      <Phone
                        id="enrollment-tel"
                        country="US"
                        nativeExpanded={true}
                        flagsPath="./static/img/flags/"
                        onChange={e => this.handlePhoneInput(e)}
                        ref={(input) => {this.photoPhone = input}}
                        required
                        aria-required="true"
                        aria-invalid={!isValidPhoneNumber(this.state.textPhone)}
                      />
                    </li>
                  </ul>
                  <button className="btn" type="submit"><icons.iconLink />{translation.photo_id.phone.submit}</button>
                  <a className="cancel" href="#id-options" onClick={(e) => {this.toggleTextForm(e)}}>{translation.cancel}</a>
                </form>
              }

              {this.state.textFormSent &&
                <div>
                  <strong className="action-response action-response--success"><icons.iconCheck /><span className="meta">{translation.photo_id.phone.success}</span></strong>

                  <p>{translation.photo_id.phone.success_body}</p>

                  {translation.photo_id.phone.resend_label} <button className="btn--link" onClick={(e) => {this.toggleTextForm(e)}}>{translation.photo_id.phone.resend_button}</button>.
                </div>
              }
            </section>
          }

          {!prod &&
            <section id="voice-options" className={`panel panel--brief ${this.isActive(4)}`}>
              <h2 className="panel__title">{translation.voice.heading}</h2>

              {!this.state.hasRecorded && !this.state.showVoicePhone &&
                <h5>{translation.voice.sub_heading}</h5>
              }

              {this.state.recordingSupport &&
                <div>
                  {this.state.hasRecorded && !this.state.voiceRecording &&
                    <div className="recorder-passage">
                      <strong>{translation.voice.record.heading}</strong>
                      <p>{translation.voice.record.passage}</p>
                    </div>
                  }

                  {!this.state.showVoicePhone &&
                    <AudioRecorder startRecording={this.startRecording} setRecording={this.setVoice} removeRecording={this.removeVoice}  {...this.props} />
                  }

                  {!this.state.hasRecorded && !this.state.showVoicePhone &&
                    <div>
                      <span className="preposition--vertical">{translation.voice.or}</span>
                      <a href="#phone-info" onClick={(e) => {this.toggleVoicePhone(e)}}>{translation.voice.phone.button}</a>
                    </div>
                  }
                </div>
              }

              {(this.state.showVoicePhone || !this.state.recordingSupport) &&
                <div id="phone-info">
                  <p>{translation.voice.phone.instruction_start} (800) 777-7777 {translation.voice.phone.instruction_end}</p>
                  <strong className="text-code">A47BC</strong>

                  {this.state.recordingSupport &&
                    <a className="cancel" href="#voice-options" onClick={(e) => {this.toggleVoicePhone(e)}}>{translation.cancel}</a>
                  }
                </div>
              }

              {this.state.voiceRecording &&
                <a className="btn btn--icn-right next" href="#" onClick={(e) => {this.nextStep(e)}}>
                  {translation.continue}
                  <icons.iconCircleRight />
                </a>
              }
            </section>
          }

          {/* <section className={`panel panel--brief ${this.isActive(5)}`}>
            <h2 className="panel__title">{translation.preferences.heading}</h2>
            <h5>{translation.preferences.sub_heading}</h5>

            <ul className="fields">
              <li>
                <label className="lbl-required" htmlFor="enrollment-zip">{translation.preferences.postal_code.label}</label>
                <input type="text" id="enrollment-zip" placeholder={translation.preferences.postal_code.helper} />
              </li>
            </ul>

            <ul className="switch-list">
              {translation.preferences.options.map(
                  (key, i) =>
                  <li key={i}>
                    <label htmlFor={`pref-${i}`}>{key.label}</label>
                    <input type="checkbox" id={`pref-${i}`} className="switch-input" value="1" />
                    <label htmlFor={`pref-${i}`} className="switch-label"><span className="meta">{key.label}</span></label>
                  </li>
                )
              }
            </ul>

            <Link className="btn next" to="/student-dashboard">{translation.complete}</Link>
          </section> */}
        </div>
      </main>
    );
  }
})

export default translate('LegacyEnrollment')(LegacyEnrollment);


// WEBPACK FOOTER //
// ./src/app/components/Enroll/LegacyEnrollment.js